// Libs
import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import EventEmitter from 'eventemitter3'
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment'
import _throttle from 'lodash/throttle'
import ReactGA from 'react-ga'

let EE
let viewport = { width: 1366, height: 768 } // Default size for server-side rendering
const RESIZE_EVENT = 'resize'

function handleWindowResize () {
  if (viewport.width !== window.innerWidth || viewport.height !== window.innerHeight) {
    viewport = { width: window.innerWidth, height: window.innerHeight }
    EE.emit(RESIZE_EVENT, viewport)
  }
}

function withViewport (WrappedComponent) {
  class WithViewport extends Component {
    viewportMounted = false // track wrapped component status

    constructor () {
      super()

      this.state = {
        viewport: canUseDOM ? { width: window.innerWidth, height: window.innerHeight } : viewport,
      }
      this.handleResize = this.handleResize.bind(this)
    }

    handleResize (value) {
      if (this.viewportMounted) {
        this.setState({ viewport: value }) // eslint-disable-line react/no-set-state
      }
    }

    componentDidMount () {
      if (!EE) {
        EE = new EventEmitter()
        window.addEventListener('resize', handleWindowResize)
        window.addEventListener('orientationchange', handleWindowResize)
      }

      EE.on(RESIZE_EVENT, _throttle(this.handleResize, 100), this)
      this.viewportMounted = true
      if (this.props.history) {
        // Send page view to Google Analytics
        ReactGA.pageview(this.props.history.location.pathname)
      }
    }

    componentWillUnmount () {
      if (EE) {
        EE.removeListener(RESIZE_EVENT, this.handleResize, this)
        if (!EE.listeners(RESIZE_EVENT, true)) {
          window.removeEventListener('resize', handleWindowResize)
          window.removeEventListener('orientationchange', handleWindowResize)
          EE = null
        }
      }
      this.viewportMounted = false
    }

    render () {
      return <WrappedComponent {...this.props} viewport={this.state.viewport} />
    }
  }

  return WithViewport
}

export default withViewport
